import http from '../../http';
import { SERVER_URL } from '../../config';

export const getSinglePostData = (params) => http.get(`${SERVER_URL}/api-main/v1/post`, {params: {...params}});